<template>
  <div class="period-lock">
    <h2>Периоды</h2>

    <!-- Блок в рамке, как на новом внесении данных: полоса управления сверху, таблица под ней -->
    <div class="period-panel">
      <div class="period-panel__toolbar">
        <template v-if="getPeriodsDataSize(periodsData) === 0">
          <el-date-picker
            class="period-panel__date"
            v-model="periodsData.newDate"
            value-format="yyyy-MM"
            type="month"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-button type="primary" @click="createPeriod"> Добавить</el-button>
        </template>

        <template v-else>
          <el-button type="primary" @click="addPeriod"> Добавить</el-button>
        </template>
      </div>

      <!-- Шапка и «Добавить» на месте, прокручиваются только строки - как таблица внесения данных -->
      <div class="period-panel__body">
        <el-table
          :data="periodsData"
          height="100%"
          class="period-table"
          :row-class-name="periodRowClass"
        >
          <el-table-column label="ID" width="90">
            <template #default="{ row }">
              <div class="period-table__line period-table__muted">
                {{ row.periodId }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Период" width="140">
            <template #default="{ row }">
              <div class="period-table__line">
                <div class="period-table__date">
                  {{
                    (new Date(row.date).getMonth() + 1).toString().padStart(2, "0") +
                    "." +
                    new Date(row.date).getFullYear()
                  }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Пользователи" min-width="300">
            <template #default="{ row }">
              <el-tree
                class="period-users"
                :data="treeData"
                show-checkbox
                node-key="id"
                :props="defaultProps"
                :ref="'userTree' + row.periodId"
                :check-on-click-node="true"
                :default-checked-keys="getSelectedUsers(row)"
                @check="updateCheckedUsers(row)"
              />
            </template>
          </el-table-column>

          <el-table-column label="Управление" width="160">
            <template #default="{ row }">
              <div class="period-table__line">
                <!-- Активна только при несохранённых изменениях в выборе пользователей -->
                <el-button
                  :disabled="!hasUnsavedChanges(row)"
                  :type="hasUnsavedChanges(row) ? 'warning' : 'success'"
                  size="mini"
                  style="float: left"
                  @click="lockPeriod(row)"
                  >{{ "Заблокировать" }}
                </el-button>
                <!-- Пересчёт пока не работает — скрыт до исправления -->
                <el-button
                  v-if="false"
                  size="mini"
                  style="float: left"
                  @click="reEvalutPeriod(row.periodId)"
                  type="primary"
                  >{{ "Пересчитать" }}
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import notification from "@/mixins/notification";
import Cookies from "js-cookie";

export default {
  name: "periodLockMain",
  mixins: [notification],
  data() {
    return {
      pickerOptions:{
        firstDayOfWeek: 1
      },
      userId: Cookies.get("userId"),
      role: Cookies.get("role"),
      newDate: null,
      defaultProps: {
        children: "children",
        label: "label",
      },
      treeData: [],
      // periodId -> отмеченные в дереве userId (без узла «Все»)
      checkedUsersByPeriod: {},
    };
  },

  computed: {
    ...mapGetters({
      periodsData: "GETLISTPERIODS",
      allUsersData: "GETTREEUSERS",
    }),
  },

  watch: {
    allUsersData: {
      immediate: true,
      handler(newUsers) {
        this.treeData = this.formatUsers(newUsers);
      },
    },
  },

  methods: {
    getListPeriods() {
      this.$store.dispatch("getTreeUsers").then(() => {
        this.$store.dispatch("getListPeriods").then(() => {
          this.periodsData.forEach((period) => {
            //period.USLength = this.$refs['userTree' + period.periodId].getCheckedKeys().filter((id) => id == 0).length;
            let UserChekId = [];
            period.users.forEach((us) => {
              UserChekId.push(us.userId);
            });
            if (period.users.length == this.allUsersData.length)
              UserChekId.push(0);
            console.log(UserChekId);
            this.$refs["userTree" + period.periodId].setCheckedKeys(UserChekId);
            this.updateCheckedUsers(period);
            console.log(
              this.$refs["userTree" + period.periodId].getCheckedKeys()
            );
            console.log(this);
            console.log(this.allUsersData);
            period.selectedUsers = [];
          });
        });
      });
    },

    /*changeThree(row)
    {
      console.log(row);
      row.USLength = this.$refs['userTree' + row.periodId].getCheckedKeys().filter((id) => id == 0).length;
    },*/

    updateCheckedUsers(row) {
      const treeRef = this.$refs["userTree" + row.periodId];
      if (!treeRef) return;
      this.$set(
        this.checkedUsersByPeriod,
        row.periodId,
        treeRef.getCheckedKeys().filter((id) => id !== 0)
      );
    },

    hasUnsavedChanges(row) {
      const checked = this.checkedUsersByPeriod[row.periodId];
      if (!checked) return false;
      const saved = row.users.map((us) => us.userId);
      return (
        checked.length !== saved.length ||
        checked.some((id) => !saved.includes(id))
      );
    },

    periodRowClass({ row }) {
      return this.hasUnsavedChanges(row) ? "is-changed" : "";
    },

    getSelectedUsers(row) {
      row.user;
      return ["userId1", "userId2", "userId3"]; // Этот массив содержит выбранные пользователи
    },
    formatUsers(users) {
      return [
        {
          label: "Все",
          id: 0,
          children: users.map((user) => ({
            id: user.userId,
            label: user.username,
          })),
        },
      ];
    },

    getPeriodsDataSize(periodsData) {
      return periodsData.length;
    },
    /*
    canLockPeriod(index) {
      if (!this.periodsData || this.periodsData.length === 0) {
        return false;
      }
      if (index === 0) {
        return true;
      }
      const previousPeriod = this.periodsData[index - 1];
      return previousPeriod.lock === true;
    },*/

    addPeriod() {
      let data = {
        periodInfo: {
          lock: false,
        },
      };
      this.$store.dispatch("addNewPeriod", data).then(() => {
        this.$store.dispatch("getListPeriods");
      });
    },

    createPeriod() {
      let data = {
        periodInfo: {
          dateInfo: this.periodsData.newDate,
        },
      };
      this.$store.dispatch("createNewPeriod", data).then(() => {
        this.$store.dispatch("getListPeriods");
      });
    },

    lockPeriod(row) {
      const treeRef = this.$refs["userTree" + row.periodId];
      let selectedUsers = treeRef.getCheckedKeys().filter((id) => id !== 0);
      let data = {
        periodId: row.periodId,
        userIds: selectedUsers,
      };
      console.log(data);
      this.$store.dispatch("lockPeriod", data).then(() => {
        this.getListPeriods();
      });
    },
    reEvalutPeriod(periodId) {
      this.$store.dispatch("reEvalutPeriod", periodId);
    },
  },

  mounted() {
    this.getListPeriods();
    this.$store.dispatch("getListPeriods");
  },
};
</script>

<style scoped>
/* Заголовок и рамки - как на новом внесении данных (dataEntryNew) */
.period-lock {
  height: var(--content-min-height, 100vh);
}
.period-lock > h2 {
  margin: 0 0 16px;
  line-height: 40px;
}
/* Заголовок с отступом под ним - 40 + 16 */
.period-panel {
  height: calc(100% - 56px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  /* Цвет el-divider и рамок блоков внесения данных */
  border: 1.5px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
/* Полоса управления - как строка поиска над деревом подразделений */
.period-panel__toolbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid #ebeef5;
  background: #fafbfc;
}
.period-panel__date {
  width: 180px;
}
.period-panel__toolbar .el-button {
  margin-left: 0;
}
.period-panel__body {
  flex: 1;
  min-height: 0;
}
/* Нижняя линия el-table прилегает к рамке и делала её двойной */
.period-table::before {
  display: none;
}
/* Шапка - как у таблицы внесения данных */
.period-table ::v-deep th > .cell {
  font-size: 13px;
  font-weight: 600;
  color: #909399;
}
/* По верху: при раскрытом дереве ID, период и кнопка остаются напротив строки «Все» */
.period-table ::v-deep td {
  vertical-align: top;
}
/* Высота - как у свёрнутого дерева: строка 26 + отступы 4 + 4 + рамка 1 + 1 */
.period-table__line {
  display: flex;
  align-items: center;
  height: 36px;
}
/* Несохранённый выбор пользователей - строка подсвечена, как кнопка «Заблокировать» */
.period-table ::v-deep tr.is-changed > td {
  background: #fdf6ec;
}
.period-table ::v-deep tr.is-changed > td:first-child {
  box-shadow: inset 3px 0 #e6a23c;
}
.period-table__muted {
  color: #909399;
  font-variant-numeric: tabular-nums;
}
/* Период - плашкой, как месяц в календаре дат */
.period-table__date {
  display: inline-block;
  padding: 3px 12px;
  border: 1px solid #ebeef5;
  border-radius: 14px;
  background: #fff;
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
/* Дерево пользователей - в своей рамке, как подразделения на внесении данных */
.period-users {
  max-width: 640px;
  padding: 4px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafbfc;
}
.period-users ::v-deep .el-tree-node__content {
  border-radius: 4px;
  transition: background-color 0.15s;
}
.period-users ::v-deep .el-tree-node__content:hover {
  background: #ecf5ff;
}
/* Логины крупнее и темнее, строки чуть выше - чтобы не сливались */
.period-users ::v-deep .el-tree-node__children .el-tree-node__content {
  height: 30px;
}
.period-users ::v-deep .el-tree-node__label {
  font-size: 15px;
  color: #303133;
}
.period-users ::v-deep .el-tree-node__children .el-tree-node__label {
  font-weight: 500;
}
</style>
